import React from 'react';
import PropTypes from 'prop-types';

import './PromoCheckoutBanner.css';
import imgLeft from '../../assets/promos/nn-banner-checkout-mrskin.jpg';


const PromoCheckoutBanner = (props) => {
  const { checkoutImage, showPromoInput, shouldShowPromoCheckoutBanner } = props;

  if (showPromoInput && shouldShowPromoCheckoutBanner) {
    return (
      <div className="offer-area easter" style={{ marginBottom: '5px' }}>
        <img alt={'promo-img'} className="left-img" src={checkoutImage} />
        <div className="clearfix" />
      </div>
    );
  }

  return null;
};

export default PromoCheckoutBanner;

PromoCheckoutBanner.defaultProps = {
  checkoutImage: imgLeft,
  showPromoInput: false,
  shouldShowPromoCheckoutBanner: false,
};

PromoCheckoutBanner.propTypes = {
  checkoutImage: PropTypes.string,
  shouldShowPromoCheckoutBanner: PropTypes.bool,
  showPromoInput: PropTypes.bool,
};


